











import { Component, Mixins } from 'vue-property-decorator';
import SDatepickerBase from './SDatepickerBase.vue';
import SFormElement from './SFormElement.vue';

@Component({
  components: {
    SDatepickerBase,
  },
})
export default class SDatepicker extends Mixins(SFormElement) {}
